import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import api, { resolveAssetUrl } from "@/lib/api";
import useSettings from "@/lib/useSettings";
import { Mail, Phone, MapPin, Facebook, ExternalLink } from "lucide-react";

export default function Footer() {
  const settings = useSettings();
  const [visits, setVisits] = useState({ total: 0, month: 0 });

  useEffect(() => {
    // Track visit only once per browser session to avoid spamming on every page nav
    if (!sessionStorage.getItem("sr_visit_tracked")) {
      sessionStorage.setItem("sr_visit_tracked", "1");
      api.post("/visits/track").catch(() => {});
    }
    api.get("/visits").then((r) => setVisits(r.data)).catch(() => {});
  }, []);

  return (
    <footer
      className="mt-24 pt-14 pb-6"
      style={{ background: "#0a0807", borderTop: "1px solid var(--sr-border)" }}
      data-testid="main-footer"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <p className="text-center font-display italic mb-12" style={{ color: "var(--sr-cream)", fontSize: "clamp(0.95rem, 2vw, 1.5rem)" }}>
          „NIE JESTEŚ SAM, GDY MASZ BRACI U SWOJEGO BOKU.”
        </p>
        <div className="grid md:grid-cols-4 gap-10 pt-10 border-t" style={{ borderColor: "var(--sr-border)" }}>
          <div>
            <h4 className="font-nav text-sm uppercase mb-5" style={{ color: "var(--sr-cream)" }}>Szybkie linki</h4>
            <ul className="space-y-2 text-sm" style={{ color: "var(--sr-muted)" }}>
              <li><Link to="/o-klubie" className="hover:text-[var(--sr-fire)]">O klubie</Link></li>
              <li><Link to="/galeria" className="hover:text-[var(--sr-fire)]">Galeria</Link></li>
              <li><Link to="/logowanie" className="hover:text-[var(--sr-fire)]">Logowanie</Link></li>
              <li><Link to="/kontakt" className="hover:text-[var(--sr-fire)]">Kontakt</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-nav text-sm uppercase mb-5" style={{ color: "var(--sr-cream)" }}>Kontakt</h4>
            <ul className="space-y-3 text-sm" style={{ color: "var(--sr-muted)" }}>
              <li className="flex items-center gap-3"><Mail size={15} className="text-[var(--sr-fire)]" /> {settings.contact_email || "—"}</li>
              <li className="flex items-center gap-3"><Phone size={15} className="text-[var(--sr-fire)]" /> {settings.contact_phone || "—"}</li>
              <li className="flex items-center gap-3"><MapPin size={15} className="text-[var(--sr-fire)]" /> {settings.contact_address || "—"}</li>
            </ul>
          </div>
          <div>
            <h4 className="font-nav text-sm uppercase mb-5" style={{ color: "var(--sr-cream)" }}>Znajdź nas</h4>
            {settings.fb_url ? (
              <a
                href={settings.fb_url}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-3 text-sm hover:text-[var(--sr-fire)] cursor-pointer"
                style={{ color: "var(--sr-muted)" }}
                data-testid="footer-facebook"
              >
                <Facebook size={18} className="text-[var(--sr-fire)]" /> Facebook
              </a>
            ) : (
              <span className="text-sm" style={{ color: "var(--sr-muted)" }}>—</span>
            )}
          </div>
          <div data-testid="footer-prm">
            <h4 className="font-nav text-sm uppercase mb-5" style={{ color: "var(--sr-cream)" }}>Członek PRM</h4>
            <a
              href={settings.prm_url || "https://prm1978.pl/"}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-start gap-3 hover:opacity-90 cursor-pointer"
              data-testid="footer-prm-link"
            >
              {settings.prm_logo_url ? (
                <img
                  src={resolveAssetUrl(settings.prm_logo_url)}
                  alt="Polski Ruch Motocyklowy 1978"
                  style={{ width: 56, height: 56, objectFit: "contain", flexShrink: 0 }}
                />
              ) : null}
              <div className="text-sm">
                <div className="font-display text-[var(--sr-cream)]">Polski Ruch Motocyklowy 1978</div>
                <div className="flex items-center gap-1 mt-1" style={{ color: "var(--sr-fire-2)" }}>
                  prm1978.pl <ExternalLink size={11} />
                </div>
                <p className="mt-2 text-xs" style={{ color: "var(--sr-muted)" }}>
                  Scythe Riders jest członkiem PRM 1978.
                </p>
              </div>
            </a>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t flex flex-col sm:flex-row items-center justify-between gap-2" style={{ borderColor: "var(--sr-border)" }}>
          <p className="text-xs" style={{ color: "var(--sr-muted)" }}>
            © {new Date().getFullYear()} Scythe Riders. Wszelkie prawa zastrzeżone.
          </p>
          <p className="text-[10px] opacity-60" style={{ color: "var(--sr-muted)" }} data-testid="visit-counter">
            Odwiedzin łącznie: <span className="text-[var(--sr-fire-2)]">{visits.total}</span> · w tym miesiącu:{" "}
            <span className="text-[var(--sr-fire-2)]">{visits.month}</span>
          </p>
        </div>
      </div>
    </footer>
  );
}
